import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";

/**
 *
 */
export var Identity = /*#__PURE__*/function () {
  function Identity() {
    _classCallCheck(this, Identity);
  }

  _createClass(Identity, [{
    key: "suitableFor",
    value: function suitableFor(role) {
      var _a, _b;

      return (_b = (_a = this.userAuthorities) === null || _a === void 0 ? void 0 : _a.includes(role)) !== null && _b !== void 0 ? _b : false;
    }
  }]);

  return Identity;
}();
export var AnonymousIdentity = /*#__PURE__*/function () {
  function AnonymousIdentity() {
    _classCallCheck(this, AnonymousIdentity);

    this.id = '00000000-0000-0000-0000-000000000000';
  }

  _createClass(AnonymousIdentity, [{
    key: "suitableFor",
    value: function suitableFor(role) {
      return false;
    }
  }]);

  return AnonymousIdentity;
}();